export default "__VITE_ASSET__Bqc137sR__"